import React, { useState } from "react";
import useSWR from "swr";
import { Link } from "react-router-dom";
import { api, fmtDateTime, relativeTime } from "@/lib/api";
import { Skeleton, StatusPill, PriorityDot } from "@/components/Atoms";

const fetcher = (u) => api.get(u).then((r) => r.data);

export default function CRMTickets() {
  const { data } = useSWR("/tickets", fetcher, { refreshInterval: 10000 });
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");

  const filtered = (data || []).filter(t => (
    (!status || t.status === status) &&
    (!priority || t.priority === priority)
  ));

  return (
    <div className="space-y-5">
      <div>
        <div className="rc-title-1">Tickets</div>
        <div className="rc-callout">All queries assigned to you, with SLA timers.</div>
      </div>

      <div className="rc-card rc-card-padded flex gap-2 flex-wrap items-center">
        <select className="rc-input !w-auto !h-10 !text-[14px]" value={status} onChange={e=>setStatus(e.target.value)} data-testid="filter-status">
          <option value="">All status</option><option value="open">Open</option><option value="in_progress">In Progress</option><option value="resolved">Resolved</option><option value="closed">Closed</option>
        </select>
        <select className="rc-input !w-auto !h-10 !text-[14px]" value={priority} onChange={e=>setPriority(e.target.value)} data-testid="filter-priority">
          <option value="">All priority</option><option>P1</option><option>P2</option><option>P3</option><option>P4</option>
        </select>
        <div className="rc-footnote ml-auto">{filtered.length} tickets</div>
      </div>

      {!data && <Skeleton h={240}/>}

      <div className="rc-card rc-card-padded overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-5 py-5">
        <table className="w-full text-left" style={{ minWidth: 760 }}>
          <thead><tr className="rc-caption uppercase"><th className="py-2 pr-3 whitespace-nowrap">Subject</th><th className="py-2 pr-3 whitespace-nowrap">Category</th><th className="py-2 pr-3 whitespace-nowrap">Pri</th><th className="py-2 pr-3 whitespace-nowrap">Status</th><th className="py-2 pr-3 whitespace-nowrap">SLA</th><th className="py-2 pr-3 whitespace-nowrap">Updated</th></tr></thead>
          <tbody>
            {filtered.map(t => (
              <tr key={t.ticket_id} className="border-t border-[var(--rc-line)]">
                <td className="py-3 pr-3 max-w-[280px]"><Link to={`/crm/tickets/${t.ticket_id}`} className="rc-headline hover:underline truncate block" data-testid={`tix-link-${t.ticket_id}`}>{t.subject}</Link><div className="rc-caption">#{t.ticket_id.slice(0,8)}</div></td>
                <td className="py-3 pr-3 rc-body whitespace-nowrap">{t.category}</td>
                <td className="py-3 pr-3 whitespace-nowrap"><div className="flex items-center gap-1"><PriorityDot priority={t.priority}/>{t.priority}</div></td>
                <td className="py-3 pr-3 whitespace-nowrap"><StatusPill status={t.sla_breached ? "breached" : t.status}/></td>
                <td className="py-3 pr-3 rc-footnote whitespace-nowrap">{fmtDateTime(t.sla_deadline)}</td>
                <td className="py-3 pr-3 rc-footnote whitespace-nowrap">{relativeTime(t.updated_at)}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="py-10 rc-footnote text-center">No tickets match the filters.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
